import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';
import Ajax from './AJAX.jsx';

class Logout extends React.Component {
   constructor(props)
   {
      super(props);
     
     this.state = new Object();
     this.state.loggedInOutState = {loggedOut:false, receivedResponse:false};
      
   }

   componentDidMount()
   {

      console.log("Mouting logout");
      var onComplete = function(response)
      {

         var responseObj = JSON.parse(response);
         if(!responseObj.success)
         {
            console.log("Logout somehow failed!");
         }
         var newLogInOutState = this.state.loggedInOutState;
         newLogInOutState.receivedResponse = true;
         newLogInOutState.loggedOut = responseObj.success;

         this.setState({loggedInOutState:newLogInOutState});
      }.bind(this);

   this.props.appCallbacks.performAjaxRequest("logout", "GET", null, onComplete.bind(this));
   }

   render() {
      return (
         <div>
            <h1>Logging User Out</h1>
            <h2>{(!this.state.loggedInOutState.receivedResponse ? 'Awaiting log out' : this.state.loggedInOutState.loggedOut ? 'you have been logged out' : 'log out somehow failed')}</h2>
         </div>
      );
   }
}

export default Logout;


// WEBPACK FOOTER //
// ./js/LogOut.jsx